import SearchWidgetComponent from './searchWidget.component';
import './searchWidget.scss';

let module = angular.module('searchWidget', [])
.component('searchWidget', SearchWidgetComponent)
.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/searchWidget/searchWidget.js